import styled from 'styled-components';
import { Box, Typography } from '../../../elements';
import { ToggleButton } from '@mui/material';

export const SelectButton = styled(ToggleButton).attrs({
})`
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  color: #374659 !important;
  margin-right: 0.5rem !important;
  border-radius: 50px !important;
  text-transform: capitalize !important;
  background: #F7F8FC !important;
  border: none !important;
`;

export const Title = styled(Typography)`
  font-size: 24px;
  font-weight: 600;
`;

export const OptionsTitle = styled(Typography)`
  font-size: 20px;
  margin-top: 32px;
`;

export const OptionsWrapper = styled(Box).attrs({
  flexDirection: { xs: 'column', md: 'row' }
})`
  display: ${({ time }) => time ? 'grid' : 'flex'};
  margin-top: 0.75rem;
`;

export const Container = styled(Box).attrs({
  py: '2rem',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})``;
